let initCallbacks = [];
let recaptchaLoaded = false;
let recaptchaWidgets = {};
let defaultElementId = 'captcha-container';
let captchaVerified = {'captcha-container': false};

export function handleCaptcha(callback, elementId = defaultElementId, executeOnce = false) {
  return function(e){
    if (
      window.$jBoard.config.disable_recaptcha ||
      captchaVerified[elementId] ||
      $(`#${elementId}`).length === 0 ||
      recaptchaWidgets[elementId] === undefined
    ) {
      return callback(e);
    } else {
      e.preventDefault();

      grecaptcha.execute(recaptchaWidgets[elementId]);

      if (executeOnce) {
        captchaVerified[elementId] = true;
      }
    }

    return false;
  };
}

export function resetCaptchaVerificationStatus(elementId = defaultElementId) {
  captchaVerified[elementId] = false;
}

export function resetCaptcha(elementId = defaultElementId) {

  if ($(`#${elementId}`).length === 0) {
    return;
  }

  if (!window.$jBoard.config.disable_recaptcha) {
    grecaptcha.reset(recaptchaWidgets[elementId])
  }
}

export function initCaptcha(callback, elementId = defaultElementId){
  if (window.$jBoard.config.disable_recaptcha) {
    return;
  }

  if ($(`#${elementId}`).length === 0) {
    return;
  }

  initCallbacks.push(function(){
    try {
      let captchaWidgetId = grecaptcha.render(elementId, {
        'sitekey' : window.$jBoard.config.google_recaptcha_site_key,
        'size': 'invisible',
        'callback' : function(){
          callback();
        },
        //
        // 'error-callback': () => {
        //   //
        // },
        // 'expired-callback': () => {
        //   //
        // }
        //
      });

      recaptchaWidgets[elementId] = captchaWidgetId;
    } catch(e) {
      //seems this is some bug related to either jQuery, or captcha, so we ignore this
    }

  });

  if (recaptchaLoaded) {
    executedInitCallbacks();
  }
}

function executedInitCallbacks() {
  for (let callback of initCallbacks) {
    callback();
  }
}

function onloadRecaptchaCallback(){
  recaptchaLoaded = true;
  executedInitCallbacks();

  if (window && window.bablic) {
    window.bablic.element('.grecaptcha-logo iframe').exclude().done();
  }
}

window.onloadRecaptchaCallback = onloadRecaptchaCallback;
